export const blockIconsNotificationAccountTree = (
	<span className='material-symbols-outlined'>account_tree</span>
);
